export enum ArchiveTaskbarItem{
  SEARCH_BUILDER= 'search-builder',
  RECENT_SEARCHES= 'recent-searches',
  SAVED_SEARCHES= 'saved-searches',
}

